import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors, TextColors } from '@/utils/constants';
import { blueMenuBar } from '@/utils/styles/blueMenuBar';

export const useInlineNavigationStyles = makeStyles(
  ({ spacing, typography }) => ({
    root: {
      backgroundColor: PrimaryColors.dark,
      width: '100%',
    },
    menu: {
      display: 'flex',
      padding: spacing(0, 2),
      justifyContent: 'center',
      '& .portal-menu': {
        padding: spacing(0, 3),
        height: '58px',
        color: TextColors.light,
        fontSize: '15px',
        fontFamily: typography.fontFamily,
        letterSpacing: '0.17px',
        lineHeight: '1.69',
        ...blueMenuBar({ bottom: '0', hoverWidth: 'calc(100% - 48px)' }),
      },
      '& .portal-menu.active:after': {
        opacity: 1,
        width: 'calc(100% - 48px)',
      },
    },
  }),
  { name: 'InlineNavigation' },
);
